import { Badge } from 'reactstrap'

/**
 * Get columns for Personal Question List DataTable
 * @param {function} getAnswerStatus - Function to get answer status for a question
 * @returns {array} Column definitions for DataTable
 */
export const getPersonalQuestionColumns = (getAnswerStatus) => [
	{
		name: '#',
		selector: (row) => row.order,
		sortable: true,
		width: '10%'
	},
	{
		name: 'Question',
		selector: (row) => row.pname,
		sortable: true,
		wrap: true,
		width: '70%',
		minWidth: '400px'
	},
	{
		name: 'Status',
		selector: (row) => getAnswerStatus(row.id),
		sortable: true,
		width: '20%',
		center: true,
		cell: (row) => {
			const status = getAnswerStatus(row.id)
			return (
				<Badge color={status === 'Answered' ? 'success' : 'warning'} className="px-3 py-2">
					{status}
				</Badge>
			)
		}
	}
]
